import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import EmailOutlined from '@mui/icons-material/EmailOutlined'
import { Box, Button, CircularProgress, TextField } from '@mui/material'
import ImageBanner from 'components/image-banner'
import InviteSVG from 'components/svg/invite'

import LogoTheme from 'components/logo-theme'
import WrapperPermission from 'components/wrapper-permission'
import { useStyles } from './styles'
import useComponent from './use-component'
import { useHistory } from 'react-router-dom'

const InviteResponsible = () => {
  const {
    form: {
      register,
      handleSubmit,
      formState: { errors },
    },
    theme,
    onSubmit,
    isLoading,
    handleChange,
    handleBack,
  } = useComponent()

  const history = useHistory()
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <LogoTheme />

            <p className={classes.formTitle}>Convidar uma pessoa</p>
            <p className={classes.formSubTitle}>
              Complete o formulário com as informações do convidado para adicionar à Conducco.
            </p>

            <Box
              component='form'
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              data-testid='form'
              className={classes.formBox}
              marginTop={2}
            >
              <TextField
                required
                autoFocus
                id='responsibleName'
                type='responsibleName'
                variant='outlined'
                label='Nome'
                placeholder='Digite o nome do usuário'
                disabled={isLoading}
                error={!!errors.responsibleName}
                helperText={errors?.responsibleName?.message ?? ''}
                sx={{ mb: 4 }}
                {...register('responsibleName', { onChange: (e) => handleChange(e) })}
                InputProps={{
                  startAdornment: (
                    <AccountCircleOutlined
                      color={isLoading ? 'disabled' : 'inherit'}
                      sx={{ margin: '0 8px' }}
                    />
                  ),
                }}
              />

              <TextField
                id='responsibleEmail'
                type='responsibleEmail'
                variant='outlined'
                label='Email'
                placeholder='Digite o endereço de e-mail do convidado'
                disabled={isLoading}
                error={!!errors.responsibleEmail}
                helperText={errors?.responsibleEmail?.message ?? ''}
                sx={{ mb: 2 }}
                {...register('responsibleEmail', { onChange: (e) => handleChange(e) })}
                InputProps={{
                  startAdornment: (
                    <EmailOutlined
                      color={isLoading ? 'disabled' : 'inherit'}
                      sx={{ margin: '0 8px' }}
                    />
                  ),
                }}
              />

              <p className={classes.formSubTitle}>
                Esse usuário terá permissão para se conectar ao eSocial e, se necessário, enviar o certificado.
              </p>

              <Button
                fullWidth
                size='large'
                type='submit'
                variant='contained'
                disabled={isLoading}
                sx={{
                  mt: 2,
                  mb: 0,
                  '&.Mui-disabled': {
                    backgroundColor: '#8C9097 !important',
                    color: '#FFF !important',
                  },
                }}
              >
                {isLoading ? (
                  <CircularProgress
                    color='inherit'
                    size={26}
                  />
                ) : (
                  'ENVIAR CONVITE'
                )}
              </Button>

              <span
                onClick={() => history.push('/esocial-connect')}
                color='inherit'
                className={classes.buttons}
              >
                <ChevronLeftIcon sx={{ mr: '4px', fontSize: '24px' }} />
                Voltar
              </span>
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='Convide uma pessoa para ajudar a configurar o seu Cofre Digital.'
          banner={<InviteSVG />}
        />
      </Box>
    </Box>
  )
}

export default InviteResponsible
